<template>
  <v-layout justify-center>
    <!-- CARGANDO AGENDA -->
    <v-flex xs1 v-if="!loadedCalendar">
      <v-progress-circular
        indeterminate
        color="green"
      ></v-progress-circular>
    </v-flex>
    <!-- AGENDA CARGADA -->
    <v-flex xs12 v-if="loadedCalendar">
      <!-- PANEL EXPANDIBLE DE AÑOS-->
      <v-expansion-panel v-model="panelYears" expand :value="$store.state.activeExpansionPanel.year">
        <!-- AÑOS -->
        <v-expansion-panel-content
          v-for="(year, yearIndex) in calendar"
          :key="yearIndex"
        >
          <div slot="header" @click="setPanel({collection: 'years', id: yearIndex})">Reservas {{year.id}}</div>
          <v-card class="pa-2">
            <!-- PANEL EXPANDIBLE DE MESES -->
            <v-expansion-panel v-model="panelMonths" expand :value="$store.state.activeExpansionPanel.month">
              <!-- MESES -->
              <v-expansion-panel-content
                v-for="(month, monthIndex) in year.months"
                :key="monthIndex"
                @click.native="$store.commit('setActiveExpansionPanel', {year: yearIndex, month: monthIndex})"
              >
                <div slot="header" @click="setPanel({collection: 'months', id: monthIndex})">
                  <p class="mb-0">{{monthIndex | monthName}}
                    <span>
                      <v-avatar
                        size="20px"
                        color="light-green darken-1"
                        class="white--text"
                        v-if="month.rescount"
                      >
                        {{month.rescount}}
                      </v-avatar>
                    </span>
                  </p>
                </div>
                <v-card>
                  <v-layout>
                    <v-flex xs3 md1>
                      <!-- TABLA DE RESERVAS-->
                      <v-data-table
                        :headers="cabinHeaders"
                        :items="cabinItems"
                        hide-actions
                      >
                      <template slot="items" slot-scope="props">
                        <td class="text-xs-center py-0 days-table__row"
                          v-for="(value, valueInd) in props.item"
                        :key="valueInd"
                        >{{value | cabinName}}</td>
                      </template>
                      </v-data-table>
                    </v-flex>
                    <v-flex xs9 md11 class="month--container">
                      <!-- DÍAS DE LA SEMANA -->
                      <div class="month--header">
                        <div
                          class="month--day"
                          v-for="(day, dayInd) in month.daysArr"
                          :key="dayInd"
                        >
                          <p class="mb-0 caption grey--text text--darken-1">{{day | weekDayTable}} <span>{{dayInd + 1}}</span></p>
                        </div>
                      </div>
                      <!-- CABAÑAS DENTRO DE ESE MES -->
                      <div
                        class="month--cabins"
                        v-for="cabin in month.cabins"
                        :key="cabin.id"
                        :style="cabinWidth(month.totalDays)"
                      >
                        <div class="line" :style="`position: absolute; left: ${100 * (item)}px`" v-for="item in month.totalDays - 1" :key="item"/>
                        <!-- v-for="reservation in cabin.reservas.filter(reserva => reserva.totalDays > 0)" -->
                        <div
                          class="reservation clickable"
                          v-for="reservation in cabin.reservas"
                          :key="reservation.id"
                          :style="reservationWidth(reservation)"
                          @click="navigateTo('Reserva', {reserva: reservation.id})"
                          :title="`(${reservation.id}) ${reservation.name.firstname} ${reservation.name.lastname} (${reservation.guests})`"
                        >
                          <p
                            class="ma-0 body-2"
                            :class="{'red--text' : !reservation.breakfast, 'text--darken-4' : !reservation.breakfast}"
                          >
                            ({{reservation.id}})
                            <span v-if="reservation.totalDays > 1">{{reservation.name.firstname}} {{reservation.name.lastname}} ({{reservation.guests}})</span>
                          </p>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
  </v-layout>
</template>

<script>
import filters from '@/mixins/filters';
import mixins from '@/mixins/mixins';
// import axios from 'axios';

export default {
  mixins: [
    filters,
    mixins,
  ],
  created() {
    // eslint-disable-next-line
    if (!isNaN(this.$store.state.panelYear)) {
      console.log('year');
      console.log(this.panelYears);
      this.panelYears[this.$store.state.panelYear] = true;
    }
    // eslint-disable-next-line
    if (!isNaN(this.$store.state.panelMonth)) {
      this.panelMonths[this.$store.state.panelMonth] = true;
    }
  },
  mounted() {
    const panels = this.$el.getElementsByClassName('v-expansion-panel__header');
    for (let i = 0; i < panels.length; i += 1) {
      panels[i].classList.add('py-0');
    }
  },
  data() {
    return {
      show: false,
      isLast: 'last',
      cabinHeaders: [
        {
          text: 'Cabaña',
          align: 'center',
          sortable: false,
          value: 'cabin',
        },
      ],
      cabinItems: [
        {
          cabin: 0,
        },
        {
          cabin: 1,
        },
        {
          cabin: 2,
        },
        {
          cabin: 3,
        },
        {
          cabin: 4,
        },
        {
          cabin: 5,
        },
        {
          cabin: 6,
        },
      ],
      show: true,
      panelYears: [],
      panelMonths: [],
    };
  },
  computed: {
    calendar() {
      return this.$store.state.calendar;
    },
    loadedCalendar() {
      return this.$store.state.loadedCalendar;
    },
    active() {
      return this.$store.state.activeExpansionPanel;
    },
  },
  methods: {
    cabinColor() {
      return 'red';
    },
    cabinWidth(amount) {
      return `width: ${100 * amount}px`;
    },
    reservationWidth(reservation) {
      const width = `
        position: absolute;
        width: ${100 * (reservation.totalDays + 1)}px;
        left: ${(reservation.day - 1) * 100}px;  
      `;
      let color = null;
      switch (reservation.origin) {
        case 'AIRBNB':
          color = 'background-color: #FFD54F;';
          break;
        case 'DIRECTA':
          color = 'background-color: #FFCDD2;';
          break;
        case 'DESPEGAR':
          color = 'background-color: #81C784;';
          break;
        case 'BOOKING':
          color = 'background-color: #4FC3F7;';
          break;
        case 'EXPEDIA':
          color = 'background-color: #FFA726;';
          break;
        case 'EXTRANJEROS':
          color = 'background-color: #E57373;';
          break;
        default: color = '';
      }
      return `${width}${color}`;
    },
    setPanel(data) {
      switch (data.collection) {
        case 'years':
          console.log(this.panelYears[data.id]);
          if (!this.panelYears[data.id]) {
            this.$store.commit('setPanel', data);
          }
          break;
        case 'months':
          console.log(this.panelYears[data.id]);
          if (!this.panelMonths[data.id]) {
            this.$store.commit('setPanel', data);
          }
          break;
        default:
          break;
      }
    },
  },
};
</script>
